<template>
  <div class="gx-main-content-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: "NPage",
};
</script>

<style scoped></style>
